import React, { useMemo } from 'react';
import { Box, Typography, Paper, Stack, CircularProgress } from '@mui/material';
import { TrendingUp, TrendingFlat, TrendingDown, InfoOutlined } from '@mui/icons-material';

interface AttendanceCardProps {
  attendanceData: any; 
  isFetching: boolean;
}

export const AttendanceCard = React.memo(function AttendanceCard({ attendanceData, isFetching }: AttendanceCardProps) {
  const stats = useMemo(() => {
    const total = attendanceData?.totalStudents || 0;
    const comparecimento = (attendanceData?.totalPresent || 0) + (attendanceData?.totalLate || 0);
    const rate = total > 0 ? Math.round((comparecimento / total) * 100) : 0;
    
    return {
      total,
      comparecimento,
      rate,
      isGood: rate >= 80,
      isBad: rate < 60,
      isEmpty: total === 0
    };
  }, [attendanceData]);

  if (isFetching && !attendanceData) {
    return (
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider', display: 'flex', justifyContent: 'center' }}>
        <CircularProgress size={24} />
      </Paper>
    );
  }

  if (stats.isEmpty) {
    return (
      <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px dashed', borderColor: 'divider', bgcolor: 'background.default', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
        <InfoOutlined color="disabled" />
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Nenhum aluno ativo matriculado nesta turma. <br/> O monitoramento de catraca está pausado.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 3, border: '1px solid', borderColor: 'divider', bgcolor: 'background.paper' }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        {stats.isGood ? <TrendingUp fontSize="small" color="success" /> : 
         stats.isBad ? <TrendingDown fontSize="small" color="error" /> : 
         <TrendingFlat fontSize="small" color="warning" />}
        <Typography variant="body2" color="text.secondary" fontWeight="bold">Taxa de Presença (Hoje):</Typography>
      </Stack>
      
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography 
          variant="h2" 
          fontWeight="bold" 
          color={stats.isGood ? "success.main" : stats.isBad ? "error.main" : "warning.main"}
        >
          {stats.rate}%
        </Typography>
        <Box sx={{ textAlign: 'right' }}>
          <Typography variant="caption" display="block" color="text.secondary">Comparecimento Atual</Typography>
          <Typography variant="caption" display="block" color="text.secondary">
            {stats.comparecimento} de {stats.total} ativos
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.disabled' }}>Baseado nas catracas</Typography>
        </Box>
      </Box>
    </Paper>
  );
});